import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _daed0c8e = () => interopDefault(import('../../25/pages/anno/index.vue' /* webpackChunkName: "pages/anno/index" */))
const _3af34ee0 = () => interopDefault(import('../../25/pages/deposit-pending.vue' /* webpackChunkName: "pages/deposit-pending" */))
const _5491f8fc = () => interopDefault(import('../../25/pages/deposit-success.vue' /* webpackChunkName: "pages/deposit-success" */))
const _3f307b71 = () => interopDefault(import('../../25/pages/discover.vue' /* webpackChunkName: "pages/discover" */))
const _1853bba4 = () => interopDefault(import('../../25/pages/favorite.vue' /* webpackChunkName: "pages/favorite" */))
const _0808b652 = () => interopDefault(import('../../25/pages/font.vue' /* webpackChunkName: "pages/font" */))
const _073326d0 = () => interopDefault(import('../../25/pages/landing-page/index.vue' /* webpackChunkName: "pages/landing-page/index" */))
const _bf237e8a = () => interopDefault(import('../../25/pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _4eb36ee4 = () => interopDefault(import('../../25/pages/promotion/index.vue' /* webpackChunkName: "pages/promotion/index" */))
const _01ed1877 = () => interopDefault(import('../../25/pages/recommended-games.vue' /* webpackChunkName: "pages/recommended-games" */))
const _19f9202f = () => interopDefault(import('../../25/pages/refresh-token.vue' /* webpackChunkName: "pages/refresh-token" */))
const _5363335a = () => interopDefault(import('../../25/pages/user.vue' /* webpackChunkName: "pages/user" */))
const _59dba296 = () => interopDefault(import('../../25/pages/user/index.vue' /* webpackChunkName: "pages/user/index" */))
const _011fa24a = () => interopDefault(import('../../25/pages/user/inbox.vue' /* webpackChunkName: "pages/user/inbox" */))
const _7970a74b = () => interopDefault(import('../../25/pages/user/station-letter.vue' /* webpackChunkName: "pages/user/station-letter" */))
const _429f28fc = () => interopDefault(import('../../25/pages/user/account-setting/_category.vue' /* webpackChunkName: "pages/user/account-setting/_category" */))
const _b0f3ccfa = () => interopDefault(import('../../25/pages/user/financial-service/_category.vue' /* webpackChunkName: "pages/user/financial-service/_category" */))
const _3d938dcb = () => interopDefault(import('../../25/pages/user/promotion-receive/_category.vue' /* webpackChunkName: "pages/user/promotion-receive/_category" */))
const _63c36f46 = () => interopDefault(import('../../25/pages/user/record-query/_category.vue' /* webpackChunkName: "pages/user/record-query/_category" */))
const _3e612552 = () => interopDefault(import('../../25/pages/landing-page/vip-program.vue' /* webpackChunkName: "pages/landing-page/vip-program" */))
const _1638972e = () => interopDefault(import('../../25/pages/about/_subCategory.vue' /* webpackChunkName: "pages/about/_subCategory" */))
const _e926d33e = () => interopDefault(import('../../25/pages/anno/_id.vue' /* webpackChunkName: "pages/anno/_id" */))
const _f7554538 = () => interopDefault(import('../../25/pages/beginner/_subCategory.vue' /* webpackChunkName: "pages/beginner/_subCategory" */))
const _61fcbc34 = () => interopDefault(import('../../25/pages/casino-games/_platform.vue' /* webpackChunkName: "pages/casino-games/_platform" */))
const _39846800 = () => interopDefault(import('../../25/pages/faq/_subCategory.vue' /* webpackChunkName: "pages/faq/_subCategory" */))
const _36a9cf11 = () => interopDefault(import('../../25/pages/fish-detail/_platform.vue' /* webpackChunkName: "pages/fish-detail/_platform" */))
const _7997baf5 = () => interopDefault(import('../../25/pages/jackpot-games/_platform.vue' /* webpackChunkName: "pages/jackpot-games/_platform" */))
const _6b2c079e = () => interopDefault(import('../../25/pages/pachinko-games/_platform.vue' /* webpackChunkName: "pages/pachinko-games/_platform" */))
const _87a8a9e0 = () => interopDefault(import('../../25/pages/payment/_subCategory.vue' /* webpackChunkName: "pages/payment/_subCategory" */))
const _a2add314 = () => interopDefault(import('../../25/pages/promotion/_id.vue' /* webpackChunkName: "pages/promotion/_id" */))
const _afcb6f06 = () => interopDefault(import('../../25/pages/real-person-video/_platform.vue' /* webpackChunkName: "pages/real-person-video/_platform" */))
const _3e317219 = () => interopDefault(import('../../25/pages/rtp/_platform.vue' /* webpackChunkName: "pages/rtp/_platform" */))
const _3fd757bd = () => interopDefault(import('../../25/pages/slot-games/_platform.vue' /* webpackChunkName: "pages/slot-games/_platform" */))
const _c8c7fca2 = () => interopDefault(import('../../25/pages/terms/_subCategory.vue' /* webpackChunkName: "pages/terms/_subCategory" */))
const _daed2b14 = () => interopDefault(import('../../25/pages/topic-games/_id.vue' /* webpackChunkName: "pages/topic-games/_id" */))
const _061c5dd9 = () => interopDefault(import('../../25/pages/vip/_subCategory.vue' /* webpackChunkName: "pages/vip/_subCategory" */))
const _0b3d638e = () => interopDefault(import('../../25/pages/page/_category/_subCategory.vue' /* webpackChunkName: "pages/page/_category/_subCategory" */))
const _9c7faa0c = () => interopDefault(import('../../25/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/anno",
    component: _daed0c8e,
    alias: ["/latest-news"],
    name: "anno"
  }, {
    path: "/deposit-pending",
    component: _3af34ee0,
    name: "deposit-pending"
  }, {
    path: "/deposit-success",
    component: _5491f8fc,
    name: "deposit-success"
  }, {
    path: "/discover",
    component: _3f307b71,
    name: "discover"
  }, {
    path: "/favorite",
    component: _1853bba4,
    name: "favorite"
  }, {
    path: "/font",
    component: _0808b652,
    name: "font"
  }, {
    path: "/landing-page",
    component: _073326d0,
    name: "landing-page"
  }, {
    path: "/maintenance",
    component: _bf237e8a,
    name: "maintenance"
  }, {
    path: "/promotion",
    component: _4eb36ee4,
    name: "promotion"
  }, {
    path: "/recommended-games",
    component: _01ed1877,
    name: "recommended-games"
  }, {
    path: "/refresh-token",
    component: _19f9202f,
    name: "refresh-token"
  }, {
    path: "/user",
    component: _5363335a,
    children: [{
      path: "",
      component: _59dba296,
      name: "user"
    }, {
      path: "inbox",
      component: _011fa24a,
      name: "user-inbox"
    }, {
      path: "station-letter",
      component: _7970a74b,
      name: "user-station-letter"
    }, {
      path: "account-setting/:category?",
      component: _429f28fc,
      name: "user-account-setting-category"
    }, {
      path: "financial-service/:category?",
      component: _b0f3ccfa,
      name: "user-financial-service-category"
    }, {
      path: "promotion-receive/:category?",
      component: _3d938dcb,
      name: "user-promotion-receive-category"
    }, {
      path: "record-query/:category?",
      component: _63c36f46,
      name: "user-record-query-category"
    }]
  }, {
    path: "/landing-page/vip-program",
    component: _3e612552,
    name: "landing-page-vip-program"
  }, {
    path: "/about/:subCategory?",
    component: _1638972e,
    name: "about-subCategory"
  }, {
    path: "/anno/:id?",
    component: _e926d33e,
    alias: ["/latest-news/:id?"],
    name: "anno-id"
  }, {
    path: "/beginner/:subCategory?",
    component: _f7554538,
    alias: ["/how-to/:subCategory?"],
    name: "beginner-subCategory"
  }, {
    path: "/casino-games/:platform?",
    component: _61fcbc34,
    name: "casino-games-platform"
  }, {
    path: "/faq/:subCategory?",
    component: _39846800,
    alias: ["/qa/:subCategory?"],
    name: "faq-subCategory"
  }, {
    path: "/fish-detail/:platform?",
    component: _36a9cf11,
    name: "fish-detail-platform"
  }, {
    path: "/jackpot-games/:platform?",
    component: _7997baf5,
    name: "jackpot-games-platform"
  }, {
    path: "/pachinko-games/:platform?",
    component: _6b2c079e,
    name: "pachinko-games-platform"
  }, {
    path: "/payment/:subCategory?",
    component: _87a8a9e0,
    name: "payment-subCategory"
  }, {
    path: "/promotion/:id",
    component: _a2add314,
    name: "promotion-id"
  }, {
    path: "/real-person-video/:platform?",
    component: _afcb6f06,
    alias: ["/live-games/:platform?"],
    name: "real-person-video-platform"
  }, {
    path: "/rtp/:platform?",
    component: _3e317219,
    name: "rtp-platform"
  }, {
    path: "/slot-games/:platform?",
    component: _3fd757bd,
    name: "slot-games-platform"
  }, {
    path: "/terms/:subCategory?",
    component: _c8c7fca2,
    name: "terms-subCategory"
  }, {
    path: "/topic-games/:id?",
    component: _daed2b14,
    name: "topic-games-id"
  }, {
    path: "/vip/:subCategory?",
    component: _061c5dd9,
    name: "vip-subCategory"
  }, {
    path: "/page/:category?/:subCategory?",
    component: _0b3d638e,
    name: "page-category-subCategory"
  }, {
    path: "/",
    component: _9c7faa0c,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
